<div class="container-fluid">
  <marquee behavior="scroll" direction="left"  class="marquee-text" *ngIf="students && students?.process_fee_status === 'COMPLETE_FEE' && students?.verification_remarks">Application status - {{students?.verification_remarks}}</marquee>
  <marquee behavior="scroll" direction="left"  class="marquee-text" *ngIf="students && students?.process_fee_status === 'REGISTRATION_FEE' && students?.re_verification_remarks">Application  - {{students?.re_verification_remarks}}</marquee>
  <div class="card general-widget">
    <div class="card-header no-border padding-15">
      <ul class="creative-dots">
        <li class="bg-primary big-dot"></li>
        <li class="bg-secondary semi-big-dot"></li>
        <li class="bg-warning medium-dot"></li>
        <li class="bg-info semi-medium-dot"></li>
        <li class="bg-secondary semi-small-dot"></li>
        <li class="bg-primary small-dot"></li>
      </ul>
      <div class="row">
        <div class="col-12">
          <h4 class="m-l-50 m-t-10">
            Home
          </h4>
        </div>
        <!--<div class="col-6">
          <form class="theme-form" [formGroup]="addSessionForm">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12"></div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="form-group m-t-10 m-b-0">
                  <select class="form-control" id="name" type="name" aria-describedby="nameHelp"
                          formControlName="session_id">
                    <option [value]="session.id" *ngFor="let session of sessions">{{session?.session_name}}</option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>-->
      </div>
    </div>
    <div class="card-body m-t-20 padding-15">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 xl-100 box-col-12">
          <div class="card">
            <div class="card-header padding-15">
              <h4 class="m-l-50 m-t-10 text-capitalize">{{user?.name.toLowerCase()}} | Quick Updates</h4>
              <ul class="creative-dots">
                <li class="bg-primary big-dot"></li>
                <li class="bg-secondary semi-big-dot"></li>
                <li class="bg-warning medium-dot"></li>
                <li class="bg-info semi-medium-dot"></li>
                <li class="bg-secondary semi-small-dot"></li>
                <li class="bg-primary small-dot"></li>
              </ul>
              <!-- <div class="setting-dot">
                 <div class="setting-bg-primary position-set pull-right"><i class="fa fa-spin fa-cog"></i></div>
               </div>-->
            </div>
            <div class="card-body ">
              <div class="row">
                <div class="col-sm-6 box-col-6 xl-50 col-xl-3">
                  <div class="card  o-hidden">
                    <div class="b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center color-darkcyan">
                          <app-feather-icons [icon]="'award'"></app-feather-icons>
                        </div>
                        <div class="media-body">
                          <h6 class="text-bold">Semester - {{students?.current_semester}}</h6>
                          <h6 class="text-bold">{{students?.course?.name}}</h6>
                          <i class="icon-bg" data-feather="database"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 box-col-6 xl-50 col-xl-3">
                  <div class="card o-hidden">
                    <div class="b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center color-danger">
                          <app-feather-icons [icon]="'bookmark'"></app-feather-icons>
                        </div>
                        <div class="media-body"><span class="m-0">Enrollment Number</span>
                          <h5 class="mb-0 counter" *ngIf="students?.enrollment_no">{{students?.enrollment_no}}</h5>
                          <h5 class="mb-0 counter" *ngIf="!students || !students['enrollment_no']">-</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 box-col-6 xl-50 col-xl-3">
                  <div class="card o-hidden">
                    <div class="b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center">
                          <div class="color-warning">
                            <app-feather-icons [icon]="'clipboard'"></app-feather-icons>
                          </div>
                        </div>
                        <div class="media-body"><span class="m-0">Roll Number</span>
                          <h5 class="mb-0 counter" *ngIf="students?.roll_no">{{students?.roll_no}}</h5>
                          <h5 class="mb-0 counter" *ngIf="!students || !students['roll_no']">-</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 box-col-6 xl-50 col-xl-3">
                  <div class="card  o-hidden">
                    <div class="b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center">
                          <div class="color-cyan">
                            <app-feather-icons [icon]="'user-plus'"></app-feather-icons>
                          </div>
                        </div>
                        <div class="media-body"><span class="m-0">Pro Id</span>
                          <h5 class="mb-0 counter" *ngIf="students?.pro_id">{{students?.pro_id}}</h5>
                          <h5 class="mb-0 counter" *ngIf="!students || !students['pro_id']">-</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div class="card-body padding-15" *ngIf="students?.enrollment_no ||  students?.pro_enrollment_no">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="card p-0 shadow-sm">
              <div class="card-header padding-15 ">
                <div class="row align-items-center">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <h4 class="m-l-50 m-t-10 text-primary">LMS Login</h4>
                    <ul class="creative-dots">
                      <li class="bg-primary big-dot"></li>
                      <li class="bg-secondary semi-big-dot"></li>
                      <li class="bg-warning medium-dot"></li>
                      <li class="bg-info semi-medium-dot"></li>
                      <li class="bg-secondary semi-small-dot"></li>
                      <li class="bg-primary small-dot"></li>
                    </ul>
                  </div>
                  <div class="col-lg-4  col-md-4 col-sm-12 text-center">
                    <h6 class="font-weight-bold mb-1">Semester - {{students?.current_semester}}</h6>
                    <h6 class="font-weight-bold">{{students?.course?.name}}</h6>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12 text-center">
                  <span  class="btn btn-primary btn-lg font-size-20"
                        (click)="goToLink('https://login.cdoevgu.com/')"> Login Now</span>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
  </div>
</div>

